import { SCHOOLS } from '@src/graphql/queries/school';
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useSchools = ({ countryCode, countryCodes, searchText, type, accreditationIds, clientId, source, includeInactive = false, initialPageSize = 10, }) => {
    const { page, setPage, pageSize, setPageSize, total, items: schools, loading, error, find, orderBy, orderByDir, setOrderBy, setOrderByDir, refetch, } = usePaginatedFetchItems({
        spec: {
            countryCode,
            countryCodes,
            name: searchText,
            type: type || undefined, // if type is empty string, set to undefined
            accreditationIds,
            clientId,
            source: source || undefined, // if source is empty string, set to undefined
            includeInactive,
        },
        fetchQuery: SCHOOLS,
        dataProp: 'schools',
        initialPageSize,
    });
    return {
        schools,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        find,
        orderBy,
        orderByDir,
        setOrderBy,
        setOrderByDir,
        refetch,
    };
};
